import HeadlineText from '@/components/common/text/headline-text'
import ScreenLayout from '@/components/layout/screen-layout'
import { Heading_Section_Easy_Follow } from '@/lib/dto/home/easy-follow/easy-follow-data'

function HeadingSectionEasyFollow() {
  return (
    <ScreenLayout>
      <HeadlineText>
        {Heading_Section_Easy_Follow.heading}
      </HeadlineText>
    </ScreenLayout>
  )
}

export default HeadingSectionEasyFollow